import { useContext, useState } from 'react';

import ManageUserGroupsModal from '@atom/components/common/manageUserGroupModal/ManageUserGroupsModal';
import UserContext from '@atom/components/userDetail/UserContext';
import { Icon, IconButton, Progress } from '@atom/mui';
import { AddIcon } from '@atom/mui/icons';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';
import { pluralize } from '@atom/utilities/stringUtilities';

import { useGroupsTab } from './useGroupsTab';
import UserGroupsTable from './UserGroupsTable';

import classes from './groupsTab.module.css';

const GroupsTab = () => {
  const {
    groups,
    refetchGroups,
    page,
    setPage,
    limit,
    setLimit,
    sortDirection,
    setSortDirection,
    sortBy,
    setSortBy,
    totalCount,
    loadingGroups,
  } = useGroupsTab();
  const { user, refetch } = useContext(UserContext);

  const [manageGroupsOpen, setManageGroupsOpen] = useState<boolean>(false);

  const handleRefetch = async () => {
    await refetch();
    refetchGroups();
  };

  return (
    <>
      <div className={classes.headerContainer}>
        <div>
          {totalCount} {pluralize(totalCount, 'group')}
        </div>
        <div>
          {hasRolePermissions(ROLE_SETS.ORG_ADMIN) && (
            <IconButton onClick={() => setManageGroupsOpen(true)}>
              <Icon icon={AddIcon} />
            </IconButton>
          )}
        </div>
      </div>
      {loadingGroups ? (
        <Progress size={80} thickness={3} style={{ height: '100%' }} />
      ) : (
        groups.length > 0 && (
          <UserGroupsTable
            groups={groups}
            page={page}
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            sortDirection={sortDirection}
            setSortDirection={setSortDirection}
            sortBy={sortBy}
            setSortBy={setSortBy}
            totalCount={totalCount}
            handleRefetch={handleRefetch}
          />
        )
      )}
      <ManageUserGroupsModal
        open={manageGroupsOpen}
        onClose={() => setManageGroupsOpen(false)}
        userId={user.id}
        refetch={handleRefetch}
      />
    </>
  );
};

export default GroupsTab;
